import { getCoprincipalAccounts, isGlobalSettingsMailbox, StartupFilter, ContractsSupportedFilter, tryGetGlobalSettingsAccountMailboxInfo, } from "owa-account-source-list-store";
import { logUsage } from "owa-analytics";
import { localStorageExists } from "owa-local-storage";
import { tryBootstrapApplicationSettingsForAccount } from "./applicationSettingsCache";
import { tryBootstrapFeatureFlagsForAccount } from "./featureFlagsCache";
import { isCachingEnabled } from "./isCachingEnabled";
import { removeOrphanedCacheEntries } from "./versionedCache";

const countTrue = (count: number, value: boolean) => count + (value ? 1 : 0);

export function bootstrapSecondaryAccountSettings(): void {
    if (!localStorageExists(self) || !isCachingEnabled()) {
        return;
    }
    
    const secondaryAccounts = getCoprincipalAccounts(StartupFilter.StartingOrCompleteOrError, ContractsSupportedFilter.Any).filter(account => !isGlobalSettingsMailbox(account.mailboxInfo));
    const featureFlagResults = secondaryAccounts.map(tryBootstrapFeatureFlagsForAccount);
    const appSettingsResults = secondaryAccounts.map(tryBootstrapApplicationSettingsForAccount);
    
    removeOrphanedCacheEntries(secondaryAccounts.map(account => account.persistenceId));
    
    // Using tryGetGlobalSettingsAccountMailboxInfo: This is early-boot telemetry for secondary
    // account bootstrap. Aligned with versionedCache.ts in this package which also uses the
    // defensive tryGet variant since global account may not be fully available at boot time.
    logUsage("BootstrapSecondaryAccountSettings", tryGetGlobalSettingsAccountMailboxInfo(false), {
        numSecondaryAccounts: secondaryAccounts.length,
        featureFlagSuccess: featureFlagResults.reduce(countTrue, 0),
        appSettingsSuccess: appSettingsResults.reduce(countTrue, 0),
    });
}
